import { Box } from '@genial/components';
import React from 'react';

import { FixedFeeTermsRowLoading } from '../FixedFeeTermsRowLoading';

interface FixedFeeTermsListBottomProps {
  dataLength: number;
  isLoadingMore: boolean;
}

export const FixedFeeTermsListBottom: React.FC<FixedFeeTermsListBottomProps> = ({
  dataLength,
  isLoadingMore,
}) => {
  const hasData = dataLength > 0;

  if (hasData && !!isLoadingMore) {
    return <FixedFeeTermsRowLoading />;
  }

  return <Box h="stack.xxxs" />;
};
